import React from 'react';
import { PAGES } from '../../site/routes';
import { usePageSeo, PageHeader, Section, LinkCards } from '../../site/ui';

// embedded : la page parente (ex. serveur inconnu) gère déjà les balises SEO
function NotFoundSeo() {
  usePageSeo({ title: 'Page introuvable | AV Kamas', path: PAGES.home, noindex: true });
  return null;
}

export default function NotFoundPage({ embedded = false }) {
  return (
    <main className="bg-gray-950 text-white min-h-[60vh]">
      {!embedded && <NotFoundSeo />}
      <PageHeader
        kicker="Erreur 404"
        title="Cette page n'existe pas"
        intro="Le lien est peut-être ancien ou mal saisi. Voici les pages les plus consultées."
      />
      <Section className="pt-0 md:pt-0">
        <LinkCards
          links={[
            { to: PAGES.home, title: 'Accueil', text: 'Achat et vente de Kamas au Maroc.' },
            { to: PAGES.prices, title: 'Prix des Kamas', text: 'Les tarifs du jour sur les 20 serveurs.' },
            { to: PAGES.servers, title: 'Serveurs Dofus', text: 'Dofus 3, Dofus Rétro et Dofus Touch.' },
          ]}
        />
      </Section>
    </main>
  );
}
